<template>
  <div class='container' style="width: 90%;height: 90%">
    <div class="topButton" style="width: 1200px;height:40px">
      <!--      <span @click="StartRealPlay" class="top" style="margin-left: 10px;line-height:40px">实时</span>-->
      <!--      <span style="color: white;margin-left: 10px" @click="initCamera">实时</span>-->
      <span style="margin-left: 50px;color: white;margin-left: 20px">时间选择:<el-date-picker
        v-model="dateTimeRange"
        size="mini"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        value-format="yyyyMMddHHmmss"
      >
    </el-date-picker></span>
      <span><el-button type="primary" size="mini" @click="getURL()" style="margin-left:10px"
                       :disabled="disabled">确认</el-button></span>
      <el-button type="primary" size="mini" @click="stopPlaying()" style="margin-left: 20px" :disabled="!disabled">停止
      </el-button>
      <!--      <span><el-button type="primary" size="mini" @click="faceCaptureDialog=true,reset()" style="margin-left: 20px">人脸抓拍图片</el-button></span>-->
    </div>
    <div id="video-container" class="plug" style="width: 1200px;height: 500px;background-color: black">
      <!--    </div>-->
      <!--    <div id="video-container"></div>-->
    </div>
  </div>
</template>
<script>
  import EZUIKit from 'ezuikit-js'

  export default {
    name: 'Monitor3',
    data () {
      return {
        disabled: false,
        radio: '1',
        isLoading: false,
        alarmPointId: '',
        playbackHdURL: '',
        local1: '2',//室内或者室外
        dateTimeRange: [],
        accessToken: '',
        getPlayBackURL: {
          'version': 1,
          'method': 'camera.GetCameraEzopen',
          'params': {
            'alarmPointId': '',
            'pointName': '',
            'location': '',
            'pageNumber': 1
          },
          'token': '#',
          'id': 0
        },
        getAccess: {
          'version': 1,
          'method': 'camera.GetAccessToken',
          'params': {},
          'token': '#',
          'id': 0
        },
        dataList: {
          appKey: '',
          appSecret: ''
        }
      }
    },
    methods: {
      // change(){
      //     if(this.local1 == '1'){
      //       this.local1 = '2';
      //     }else{
      //       this.local1 = '1'
      //     }
      // },
      getURL () {
        if (this.dateTimeRange.length != 2) {
          alert('请输入正确的日期格式!')
        } else {
          this.disabled = true
          let _this = this
          let playback = ''
          let code = ''
          this.$axios.post('https://open.ys7.com/api/lapp/token/get', this.$qs.stringify(this.dataList)).then(res => {
            this.accessToken = res.data.data.accessToken
          })
          this.getPlayBackURL.params.alarmPointId = sessionStorage.getItem('alarmPointId')
          this.getPlayBackURL.params.location = 2
          document.getElementById('video-container').innerHTML = ''
          for (let val in this.getPlayBackURL.params) {
            if (this.getPlayBackURL.params[val] === '') {
              this.getPlayBackURL.params[val] = null
            }
          }
          this.$axios.post(this.$mainUrl, this.getPlayBackURL).then(res => {
            if (res.data.hasOwnProperty('result')) {
              playback = res.data.result.ezopenList[0].playbackHd
              if (res.data.result.ezopenList[0].authCode == '' || res.data.result.ezopenList[0].authCode == null) {
                code = ''
              } else {
                code = res.data.result.ezopenList[0].authCode + '@'
              }
              // code = res.data.result.ezopenList[0].authCode;
              let str = playback.indexOf('/')
              let result1 = playback.substr(0, str + 1)
              let result2 = playback.substr(str + 2, playback.length - str - 1)
              this.playbackHdURL = result1 + '/' + code + result2
              //this.playbackHdURL = playback;
              setTimeout(function () {
                let playback1 = _this.playbackHdURL + '?begin=' + _this.dateTimeRange[0] + '&end=' + _this.dateTimeRange[1]
                let accessToken1 = _this.accessToken
                let player = new EZUIKit.EZUIKitPlayer({
                  id: 'video-container', // 视频容器ID
                  accessToken: accessToken1,
                  url: playback1,
                })
              }, 1000)
            }
          })
        }

      },
      getAccessToken () {
        this.$axios.post(this.$mainUrl, this.getAccess).then(res => {
          if (res.data.hasOwnProperty('result')) {
            this.dataList.appKey = res.data.result.appKey
            this.dataList.appSecret = res.data.result.appSecret
          }
        })
      },
      stopPlaying () {
        this.disabled = !this.disabled
        let player = new EZUIKit.EZUIKitPlayer({
          id: 'video-container'
        })
        player.stop()
        document.getElementById('video-container').innerHTML = ''
      }
    },
    mounted: function () {
      this.getAccessToken()
    },

  }
</script>

<style type="text/css" scoped lang="scss">
  video {
    width: 600px;
    height: 400px;
  }

  .topButton {
    background-color: #0D1F3A;
    cursor: pointer;
  }

  .top {
    color: white;
  }

  .top:hover {
    color: #4BA2FF;
    text-decoration: underline
  }

</style>
